// extracted by mini-css-extract-plugin
module.exports = {"dotList":"Dots__dotList___3ukgW","dot":"Dots__dot___1cUo-","dotView":"Dots__dotView___1-0AK","dotView_active":"Dots__dotView_active___2vWt4"};